import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBbyfAUmaPqrXT4G8YFkBS9mYuY6BchbbA",
    authDomain: "produtos-e-coberturas-backend.firebaseapp.com",
    projectId: "produtos-e-coberturas-backend",
    storageBucket: "produtos-e-coberturas-backend.appspot.com",
    messagingSenderId: "52474710556",
    appId: "1:52474710556:web:abc095e93a28e2b82e2dd9"
};

const app = initializeApp(firebaseConfig);

export const DbGet = getFirestore(app);